/* eslint-disable no-throw-literal */
import React, { useState, useEffect, useContext, useMemo, useRef } from "react";
import styles from "./styles/card.module.css";
import { Alert } from "react-bootstrap";
import { Selector, Editor } from "../../components";
import { useMutation, useQuery } from "@apollo/client";
import { EMPLOYEES } from "../../graphql/queries/employees";
// import { CLAIM_REQUEST } from "../../graphql/mutattions";
import swal from "sweetalert";
import { useForm } from "react-hook-form";
import { DrawerContext } from "../../components/Drawer";
import DropZone from "../../components/DropZone";
import { Select } from "../../components/Input";
import { validateEmails } from "./../../pages/CreateSlip/CreateBroadcastEmail";
import { SEND_CLAIM_TREATY_NOTIFICATION } from "../../graphql/queries/treaty";
import { FaCheck } from "react-icons/fa";

const createOption = (label) => ({
  label,
  value: label,
});

// const emailRegex = /^\w+([\\.-]?\w+)*@\w+([\\.-]?\w+)*(\.\w{2,3})+$/;

function ClaimRequest({ offer, toggle, claims, participant }) {
  const renderCount = useRef(0);

  // Log when component rerenders
  useEffect(() => {
    renderCount.current += 1;
    console.log(`ClaimRequest component rendered ${renderCount.current} times`);
  });

  const { closed } = useContext(DrawerContext);
  const { data: employees, loading } = useQuery(EMPLOYEES);
  const [inputvalue, setInputvalue] = useState("");
  const [copiedMails, setCopiedMails] = useState([]);
  const [selectedableEmail, setSelectedableEmail] = useState([]);
  const { register, errors, handleSubmit, setError, reset, setValue, watch } =
    useForm();
  const [content, setContent] = useState("");
  const [files, setFiles] = useState([]);
  const [sendSingle, setSendSingle] = useState(false);
  const [contentError, setContentError] = useState(false);
  const [documentPage, setDocumentPage] = useState(-1);
  const [sendmail] = useMutation(SEND_CLAIM_TREATY_NOTIFICATION);
  const [subject, setSubject] = useState(
    `Claim Request for ${participant?.reinsurer?.re_company_name}`
  );

  const pages = useMemo(() => {
    if (claims) {
      return claims.map((claim, key) => ({
        label: `Document ${key + 1}`,
        value: key + 1,
      }));
    }
    return [];
  }, [claims]);

  useEffect(() => {
    if (employees) {
      const _emails = employees.employees.map((e) => ({
        label: e.employee_email,
        value: e.employee_email,
      }));
      setSelectedableEmail(_emails);
      console.log("Employees data loaded and processed");
    }
  }, [employees]);

  // useEffect(() => {
  //   if (closed) {
  //     reset();
  //     setContent("");
  //     setSubject(`Claim Request for ${participant?.reinsurer?.re_company_name}`);
  //     console.log("Form reset due to drawer closing");
  //   }
  // }, [closed, reset, participant]);

  // useEffect(() => {
  //   // Set initial values for form fields
  //   setValue("subject", subject);
  //   setValue("copied_emails", copiedMails);
  //   console.log("Form values updated: subject and copied_emails");
  // }, [setValue, subject, copiedMails]);

  const handleKeyDown = (event) => {
    if (!inputvalue) return;
    // eslint-disable-next-line default-case
    switch (event.key) {
      case "Enter":
      case "Tab":
        console.log("Email added via keyboard:", inputvalue);
        setInputvalue("");
        setCopiedMails([...copiedMails, createOption(inputvalue)]);
        event.preventDefault();
    }
  };

  const handleInputChange = (event) => {
    setInputvalue(event);
  };

  const handleCopiedmailChange = (value) => {
    console.log("Copied emails changed:", value);
    setCopiedMails(value ? value : []);
    setValue("copied_emails", value ? value : []);
  };

  const handleSubjectChange = (e) => {
    console.log("Subject changed:", e.target.value);
    setSubject(e.target.value);
    setValue("subject", e.target.value);
  };

  const handleSubmitSendMail = ({ subject }) => {
    console.log("Form submission initiated");
    if (content.length < 1) {
      setContentError(true);
      console.log("Submission blocked: Content is empty");
      return;
    } else {
      setContentError(false);
    }
    if (!validateEmails(copiedMails.map((e) => e.label))) {
      setError("copied_emails", "pattern", "Provide valid mails");
      console.log("Submission blocked: Invalid email format");
      return;
    }

    const formedData = {
      email_data: {
        attachments: [...files],
        copied_email: [...copiedMails.map((e) => e.label)],
        message_content: content,
        subject,
        treaty_id: offer?.treaty_id,
      },
      // single_document: sendSingle ? 1 : 0,
      // treaty_id: offer?.treaty_id,
      // treaty_participant_id: participant?.treaty_participation_id,
      // reinsurer_id: participant?.reinsurer?.reinsurer_id,
      // paged: documentPage,
      // email_component: {
      //   email_content: content,
      //   subject,
      //   copied_email: [...copiedMails.map((e) => e.label)],
      //   attachments: [...files],
      // },
    };
    console.log("Form data prepared:", formedData);
    swal({
      closeOnClickOutside: false,
      closeOnEsc: false,
      icon: "warning",
      title: "Are you sure you make a claim request ?",
      buttons: ["No", { text: "Yes", closeModal: false }],
    }).then((input) => {
      if (!input) throw null;
      console.log("Confirmation accepted, sending mail");
      sendmail({
        variables: formedData,
      })
        .then((res) => {
          console.log("Mail sent successfully:", res);
          swal("Hurray!!", "Mail sent successfully", "success");
          reset();
          setContent("");
          setSubject(
            `Claim Request for ${participant?.reinsurer?.re_company_name}`
          );
          toggle();
        })
        .catch((err) => {
          if (err) {
            console.log("Mail sending failed:", err);
            swal("Oh noes!", "The AJAX request failed!", "error");
          } else {
            swal.stopLoading();
            swal.close();
          }
        });
    });
  };
  return (
    <>
      <div className={styles.card_header}>
        <h2 className={styles.card_title}>Send Claim Document(s) Treaty</h2>
        <Alert variant="danger">
          <p>
            This session will send copies of the claim debit note to all
            associates of participating reinsurers
            {/* <strong>{participant?.reinsurer?.re_company_name}</strong> */}
          </p>
          <p>
            N.B: You can include any number of EMAILS. Press ENTER or TAB key to
            add more in "<i>cc</i>" section{" "}
          </p>
        </Alert>
      </div>
      <form
        onSubmit={handleSubmit(handleSubmitSendMail)}
        className={styles.card_body}
      >
        <div className="row mb-2">
          <div className="col-md-2">
            <label className="" htmlFor="singleDocToggle">
              Single Doc.
            </label>
          </div>
          <div className="col-md-10 ">
            <button
              id="singleDocToggle"
              type="button"
              onClick={() => {
                console.log("Single document toggle clicked");
                setSendSingle((prev) => !prev);
              }}
              style={{
                height: 30,
                width: 30,
                cursor: "pointer",
                border: "none",
              }}
              className={`${
                sendSingle ? "bg-primary" : "bg-secondary"
              } p-2 rounded d-flex align-items-center justify-content-center`}
            >
              {sendSingle && <FaCheck color="white" size={14} />}
            </button>
          </div>
        </div>
        {sendSingle && (
          <div className="row mb-2">
            <div className="col-md-2">
              <label className="" htmlFor="documentSelect">
                Document
              </label>
            </div>
            <div className="col-md-10 ">
              <Select
                id="documentSelect"
                options={pages}
                onChange={(e) => {
                  console.log("Document page selected:", e.target.value);
                  setDocumentPage(e.target.value);
                }}
              />
            </div>
          </div>
        )}
        <div className="form-group row mb-4">
          <label htmlFor="taskname" className="col-form-label col-lg-2">
            Subject
          </label>
          <div className="col-lg-10">
            <input
              id="taskname"
              ref={register({ required: "Required" })}
              name="subject"
              type="text"
              className="form-control"
              placeholder="Enter subject"
              value={subject}
              onChange={handleSubjectChange}
            />
            {errors.subject && (
              <p className="text-danger">{errors.subject.message}</p>
            )}
          </div>
        </div>
        <div className="form-group row mb-4">
          <label
            htmlFor="copied_emails_selector"
            className="col-form-label col-lg-2"
          >
            CC
          </label>
          <div className="col-lg-10">
            <Selector
              id="copied_emails_selector"
              inputValue={inputvalue}
              onInputChange={handleInputChange}
              isMulti
              value={copiedMails}
              isLoading={loading}
              onChange={handleCopiedmailChange}
              onKeyDown={handleKeyDown}
              options={selectedableEmail}
            />
            <input
              type="hidden"
              ref={register({ required: "Required" })}
              value={JSON.stringify(copiedMails)}
              name="copied_emails"
              className="form-control"
              placeholder="Enter recipients emails separated with commas"
            />
            {errors.copied_emails && (
              <p className="text-danger">{errors.copied_emails.message}</p>
            )}
          </div>
        </div>
        <div className="form-group row mb-4">
          <label className="col-form-label col-lg-2" htmlFor="message_editor">
            Message
          </label>
          <div className="col-lg-10">
            <Editor
              id="message_editor"
              value={content}
              onChange={(value) => {
                console.log("Message content updated");
                setContent(value);
              }}
            />
          </div>
          <div className="col-md-2"></div>
          <div className="col-md-10">
            {contentError && <p className="text-danger">Required</p>}
          </div>
        </div>
        <div className="form-group row mb-4">
          <label className="col-form-label col-lg-2" htmlFor="file_attachments">
            Attachment(s)
          </label>
          <div className="col-lg-10">
            <DropZone
              id="file_attachments"
              closed={closed}
              onChange={(set) => {
                console.log("Files updated:", set.length, "files");
                setFiles(set);
              }}
              multiple={true}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-form-label col-lg-2"></div>
          <div className="col-lg-10 d-flex justify-content-end">
            <button type="submit" className="btn btn-sm w-md btn-primary">
              Send Email
            </button>
          </div>
        </div>
      </form>
    </>
  );
}

export default ClaimRequest;
